import * as yup from 'yup';
import {
  features,
  buttonText,
  viewAccountURL,
  description,
  headline,
} from '../AccountFeatures/constants';
import { splitPanels } from '../CheckoutConfirmationContainer/constants';

export const appConfirmationSchema = yup
  .object({
    features: yup
      .array(
        yup.object({
          text: yup.string().required(),
          icon: yup.string().required(),
          alt: yup.string().required(),
        }),
      )
      .required(),
    viewAccountURL: yup.string().required(),
    description: yup.string().required(),
    headline: yup.string().required(),
    splitPanels: yup
      .array(
        yup
          .object({
            image: yup
              .object({
                alt: yup.string().required(),
                src: yup.string().required(),
              })
              .required(),
            alignImage: yup.string().required(),
            backgroundColor: yup.string().required(),
            content: yup.object().required(),
          })
          .required(),
      )
      .required(),
    pricingList: yup
      .object({
        puptainerLabel: yup.string(),
        shippingLabel: yup.string(),
        scooperLabel: yup.string(),
        bowlLabel: yup.string(),
        discountLabel: yup.string(),
        freeItems: yup.array(
          yup
            .object({
              label: yup.string(),
            })
            .transform(value => ({
              label: value.label,
            })),
        ),
      })
      .transform(value => ({
        puptainerLabel: value.label_puptainer,
        shippingLabel: value.label_shipping,
        scooperLabel: value.label_scooper,
        bowlLabel: value.bowl_label,
        discountLabel: value.label_discount,
        freeItems: value.free_items_list,
      })),
  })
  .transform(value => ({
    features,
    buttonText,
    viewAccountURL,
    description,
    headline,
    splitPanels,
    pricingList: value.pricing_list?.[0],
  }));
